import { Choice } from '90.quickConnect.Models/models';
import { isRecordWithProperty } from '90.quickConnect.Models/guards';

const isChoice = (field: any): field is Choice => {
  return (
    field &&
    typeof field === 'object' &&
    !Array.isArray(field) &&
    (isRecordWithProperty(field, 'label', 'string') || isRecordWithProperty(field, 'Label', 'string')) &&
    (isRecordWithProperty(field, 'value', 'string') || isRecordWithProperty(field, 'Value', 'string'))
  );
};

export default isChoice;
